import styled from 'styled-components';
import {
  compose,
  space,
  flex,
  grid,
  layout,
  typography,
  position,
  SpaceProps,
  LayoutProps,
  TypographyProps,
  PositionProps,
  FlexProps,
  GridProps,
} from 'styled-system';

type CellProps = SpaceProps &
  LayoutProps &
  TypographyProps &
  FlexProps &
  GridProps &
  PositionProps;

const Cell = styled('div')<CellProps>(
  compose(flex, layout, space, typography, position, grid)
);

export default Cell;
